/**
 * SP1 §3.2/§6 — tenant entitlements for UI gating (create-dialog surface
 * picker, dormant notices). Fail-closed: any error reads as not entitled,
 * matching the server's fail-closed lookup.
 */
import { useEffect, useState } from "react";
import { api } from "@/lib/api-client";

export interface Entitlements {
  subscribed: string[];
  remittance: boolean;
}

const FAIL_CLOSED: Entitlements = { subscribed: [], remittance: false };

export function useEntitlements(): {
  entitlements: Entitlements | null;
  isLoading: boolean;
} {
  const [state, setState] = useState<{ entitlements: Entitlements | null; isLoading: boolean }>({
    entitlements: null,
    isLoading: true,
  });

  useEffect(() => {
    let cancelled = false;
    api
      .get<Entitlements>("/entitlements")
      .then((e) => { if (!cancelled) setState({ entitlements: e, isLoading: false }); })
      .catch(() => { if (!cancelled) setState({ entitlements: FAIL_CLOSED, isLoading: false }); });
    return () => { cancelled = true; };
  }, []);

  return state;
}
